module.exports = __webpack_public_path__ + "media/icons/notes-5eb3670a.svg";